import React from "react";
import CheckBox from "../../../../shared/components/CheckBox";

function BillingCodesComp({ items, isCode, shareObj, setShareObj }) {
   const truncateText = (text, limit) => {
      if (!text) return "";
      return text.length > limit ? text.slice(0, limit) + "..." : text;
   };
   const codesReason = isCode ? items?.code : items?.order;
   const codesDescription = truncateText(items?.description, 160);
   const codeOrder = truncateText(items?.reason, 160);
   const isChecked = shareObj?.selectedCodes.some((some) => {
      return some === codesReason;
   });
   const updateSelectedCode = () => {
      const arr = JSON.parse(JSON.stringify(shareObj?.selectedCodes));
      if (
         arr.some((some) => {
            return some === codesReason;
         })
      ) {
         const index = arr.findIndex((index) => {
            return index === codesReason;
         });
         arr.splice(index, 1);
      } else {
         arr.push(codesReason);
      }
      setShareObj({ ...shareObj, selectedCodes: arr });
   };
   return (
      <div className="d-flex">
         {shareObj?.showShareButton && (
            <div>
               <CheckBox checked={isChecked} onClick={updateSelectedCode} />
            </div>
         )}
         <div style={shareObj?.showShareButton ? { marginTop: isCode ? "-2px" : "-1px" } : {}}>
            <div className={isCode ? "bc-title" : "bc-title-order"}>{codesReason}</div>
            {codesDescription && isCode && <div className="bc-subtitle">{codesDescription}</div>}
            {codeOrder && <div className={isCode ? "bc-para" : "bc-para-order"}>{`"` + codeOrder + `"`}</div>}
         </div>
      </div>
   );
}

export default BillingCodesComp;
